// Vendor Libraries
import { createAction, props } from '@ngrx/store';
export const setChartOption = createAction('[Fund Chart] Set Chart Option', props());
export const setNameInLegendOption = createAction('[Fund Chart] Set Name in Legend Option', props());
export const setDataInLegendOption = createAction('[Fund Chart] Set Data in Legend Option', props());
